import PropTypes from 'prop-types';
import { ActionIcon } from '@mantine/core';
import Tooltip from '@shared/ui/Tooltip/Tooltip';
import { CircularProgress } from 'mui/core';
import { styled } from '@mui/material/styles';
import { CheckCircleOutlineOutlined as CheckCircleOutlineOutlinedIcon, ErrorOutline as ErrorOutlineIcon } from 'mui/icons';
import cx from 'classnames';

const PREFIX = 'BaseMenuItem';
const classes = {
  hideIconIcon: `${PREFIX}-hideIconIcon`,
  showIconIcon: `${PREFIX}-showIconIcon`,
  doneIcon: `${PREFIX}-doneIcon`,
  errorIcon: `${PREFIX}-errorIcon`,
};

const StyledActionIcon = styled(ActionIcon)(({ theme }) => ({
  [`& .${classes.hideIconIcon}`]: {
    position: 'absolute',
    opacity: 0,
    transition: 'opacity 0.3s ease-out',
  },
  [`& .${classes.showIconIcon}`]: {
    opacity: 1,
    transition: 'opacity 0.3s ease-out',
  },
  [`& .${classes.doneIcon}`]: {
    height: 24,
    color: theme.colors.green,
  },
  [`& .${classes.errorIcon}`]: {
    height: 24,
    color: theme.palette.error.main,
  },
}));

const BaseMenuItem = ({
                        icon,
                        title,
                        label,
                        onClick,
                        isLoading,
                        isSuccess,
                        isFailed,
                        isDisabled,
                        buttonAlign,
                      }) => {
  // The shared hint card, like every other tooltip in the dashboard; an
  // empty title renders no tooltip at all.
  // The span keeps the tooltip working on a disabled button, which fires
  // no mouse events of its own.
  return <Tooltip title={label || ''}>
    <span style={{ display: 'inline-flex' }}>
    <StyledActionIcon style={{ height: 34, width: 'auto', justifyContent: buttonAlign }}
                onClick={onClick}
                disabled={isDisabled}>
      {!isLoading && !isSuccess && !isFailed && icon}
      <CircularProgress
        color={'primary'}
        size={20}
        className={cx(
          classes.hideIconIcon, {
            [classes.showIconIcon]: isLoading,
          })}
      />
      <CheckCircleOutlineOutlinedIcon className={cx(
        classes.hideIconIcon,
        classes.doneIcon, {
          [classes.showIconIcon]: isSuccess,
        })} />
      <ErrorOutlineIcon className={cx(
        classes.hideIconIcon,
        classes.errorIcon, {
          [classes.showIconIcon]: isFailed,
        })}
      />
      {title}
    </StyledActionIcon>
    </span>
  </Tooltip>;
};

BaseMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isFailed: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default BaseMenuItem;
